import { createContext, useEffect, useState } from "react";
import axiosClient from "../api/api";

export const PlayerContext = createContext({
  lyrics: [],
});

export default function PlayerStore({ children }) {
  const [track, setTrack] = useState({});
  const [progress, setProgress] = useState(0);

  const getPlayerState = () => {
    axiosClient.get("/track/player").then((response) => {
      if (!response) {
        return;
      }

      if (response.status === 200) {
        if (!response.data.title.length) {
          return;
        }

        if (response.data.progress !== progress) {
          setProgress(response.data.progress);
        }

        if (response.data.id === track.id) {
          return;
        }

        setTrack({
          id: response.data.id,
          title: response.data.title,
          artist: response.data.artist,
          isPlaying: response.data.isPlaying,
        });
      }
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getPlayerState();
    }, 2000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const playPause = () => {
    skipTo(0).then(() => {
      setTrack({
        ...track,
        isPlaying: !track.isPlaying,
      });
    });
  };

  const skipTo = (timestamp) => {
    return axiosClient
      .post("/track/player/modifyState", {
        state: 0,
        pos: timestamp,
      })
      .then(() => {
        setProgress(timestamp);
      });
  };

  const next = () => {
    axiosClient
      .post("/track/player/modifyState", {
        state: 1,
      })
      .then(() => {
        getPlayerState();
      });
  };

  const prev = () => {
    if (progress > 4000) {
      const t = 1000;
      skipTo(t).then(() => {
        setProgress(t);
      });
      return;
    }

    axiosClient
      .post("/track/player/modifyState", {
        state: 2,
      })
      .then(() => {
        getPlayerState();
      });
  };

  return (
    <PlayerContext.Provider
      value={{
        track: track,
        progress: progress,
        playPause: playPause,
        next: next,
        prev: prev,
        skipTo: skipTo,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
}
